/**
 * Modifies the state accordingly depending on the action dispatched.
 *
 * @param  {object} state
 * @param  {object} action
 * @return {object} state
 */
const professional = (
  state = {
    isFetching: false,
    payload: null,
    page: 1,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case 'PROFESSIONAL_INDEX_REQUEST':
    case 'PROFESSIONAL_SHOW_REQUEST':
    case 'PROFESSIONAL_DELETE_REQUEST':
      return {
        ...state,
        isFetching: true,
        payload: null,
        error: null,
      }
    case 'PROFESSIONAL_INDEX_SUCCESS':
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        page: action.payload.current_page,
        error: null,
      }
    case 'PROFESSIONAL_SHOW_SUCCESS':
    case 'PROFESSIONAL_DELETE_SUCCESS':
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null,
      }
    case 'PROFESSIONAL_INDEX_FAILURE':
    case 'PROFESSIONAL_SHOW_FAILURE':
    case 'PROFESSIONAL_DELETE_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.payload.error.toString(),
      }
    case 'PROFESSIONAL_ERROR_NULL':
      return {
        ...state,
        error: null,
      }
    default:
      return state
  }
}

export default professional
